module.exports = __webpack_public_path__ + "media/images/favicons/mstile-150x150-96cbdfc82c666fe7be80b6f92b644537.png";